module.exports = __webpack_public_path__ + "img/4.f939c1aa.png";